import { ObservableFromFetch } from "../../ObservableFromFetch"

interface ValidationResultRow {
  OriginalString: string
  Items: string[]
  Errors: string[] | null
  Warnings: string[] | null
  RowNum: number
}

export interface ImportJobValidationResult {
  Headers: string[]
  Rows: ValidationResultRow[]
  TotalRowsCount: number
  ValidRowsCount: number
}

export default function ImportJobValidateObservable(importJobID: number) {
  const params: string = JSON.stringify({ ImportJobID: importJobID })
  return ObservableFromFetch<ImportJobValidationResult>("WorkforceCompanyImport/StartValidation", params)
}
